<template>
  <div class="contain-post">
    <header>
      <p>Share an update</p>
    </header>
    <div class="post">
      <textarea
        placeholder="e.g. Hello world"
        :disabled="publishing"
        v-model="text"
      ></textarea>
      <div class="action">
        <button
          class="button is-primary is-rounded"
          :disabled="publishing"
          @click="publishNote"
        >
          Post
        </button>
      </div>
    </div>
    <footer>
      <div class="dropdown is-right is-hoverable">
        <div class="dropdown-trigger">
          <button
            class="button"
            aria-haspopup="true"
            aria-controls="dropdown-menu4"
          >
            <span>Relays</span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu4" role="menu">
          <div class="dropdown-content">
            <div class="dropdown-item">
              <small>{{ writeServersList }}</small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { pool } from "./relay";

  export default {
    props: ["reference"],
    data() {
      return {
        text: "",
        publishing: false
      };
    },
    computed: {
      writeServersList() {
        if(!Object.keys(pool.relays).length) return 'Loading...'
        return Object.keys(pool.relays)
          .filter(url => pool.relays[url].policy.write)
          .join(" ")
          .replace(/"/g, "");
      }
    },
    methods: {
      async publishNote(ev) {
        ev.preventDefault();
        this.publishing = true;

        try {
          await this.$store.dispatch("publishNote", {
            text: this.text,
            reference: this.reference
          });
          this.text = "";
          this.$emit("publish");
        } catch (err) {
          console.log("error publishing", err);
        }
        this.publishing = false;
      }
    }
  };
</script>

<style>
  .contain-post {
    padding: 2rem;
  }
  .contain-post header {
    padding: 0.75rem 0;
  }
  .post {
    box-shadow: 0 0.5em 1em -0.125em rgba(0, 0, 0, 0.1),
      0 0px 0 1px rgba(0, 0, 0, 0.02);
  }
  .contain-post footer {
    padding: 0.75rem 0;
  }
  .action {
    display: flex;
    justify-content: flex-end;

  }
  .action button {
    text-transform: uppercase;
  }
  textarea {
    position: relative;
    border: none;
    margin: 0;
    width: 100%;
    height: 100%;
    resize: none;
    padding: 1.5rem;
  }
</style>
